import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import StandardSelect from 'app/components/common/standard-select';
import helpers        from 'app/helpers/states';

class StateSelect extends React.PureComponent {

  get options() {
    const states = this.props.allowCa ? helpers.all : helpers.us;
    return Object.values(states).map((state) => {
      return {value: state.code, label: state.name};
    });
  }

  render() {
    return (
      <StandardSelect
        name="state"
        label="State"
        searchLabel="Type to filter..."
        {...this.props}
        options={this.options}
      />
    );
  }

}

StateSelect.propTypes = {
  allowCa: PropTypes.bool,
};
StateSelect.defaultProps = {
  allowCa: false,
};

export default StateSelect;
